import { reactive, toRefs } from 'vue'

const mobileMode = () => window.innerWidth < 991

const layoutState = reactive({
  sidebarVisible: !mobileMode(),
})

export function useLayout() {
  const toggleSidebar = () => {
    layoutState.sidebarVisible = !layoutState.sidebarVisible
  }
  const onSidebarLinkClicked = () => {
    if (mobileMode()) {
      layoutState.sidebarVisible = false
    }
  }

  return { layoutState: toRefs(layoutState), toggleSidebar, onSidebarLinkClicked }
}
